import { AcknowledgedByChannelsPT } from './textBuilders/AcknowledgedBy'
import { DeleteConsequencePT } from './textBuilders/DeleteConsequence'
import { FalsePositiveByChannelsPT, ResolvedByChannelsPT } from './textBuilders/StatusBy'
import { TriggerConditionExpressionPT } from './textBuilders/TriggerConditionExpression'
import { TriggerOnPT } from './textBuilders/TriggerOn'

export default {
    values: {
        TriggerConditionExpression: TriggerConditionExpressionPT,
        activeRuleDeleteMsg: 'Regras ativas não podem ser excluídas. Inative a regra para poder excluí-la.',
        DeleteConsequence: DeleteConsequencePT,
        TriggerOn: TriggerOnPT,
        deletePlaceholder: 'Digite "DELETE" para confirmar',
        'No active channels alerts related to the channels in this dashboard.':
            'Nenhuma alerta de canal ativo relacionado aos canais deste dashboard.',
        Rules: 'Regras',
        'New Rule': 'Nova regra',
        Edit: 'Editar',
        Delete: 'Deletar',
        Save: 'Salvar',
        Close: 'Fechar',
        Cancel: 'Cancelar',
        'Attribute (channel):': 'Atributo (canal):',
        'Select a channel in dashboard': 'Selecione um canal no dashboard',
        Conditional: 'Condicional',
        If: 'Se',
        if: 'se',
        'Operation:': 'Operação:',
        'Select an operation': 'Selecione uma operação',
        when: 'quando',
        sec: 'seg',
        'channels-conditional-min': 'min',
        hours: 'horas',
        then: 'então',
        'Criticality:': 'Criticidade:',
        'Select a criticality': 'Selecione uma criticidade',
        'New rule': 'Nova regra',
        Publish: 'Publicar',
        Status: 'Status',
        Inactive: 'Inativo',
        Active: 'Ativo',
        'Name:': 'Nome:',
        'Description:': 'Descrição:',
        'Alerts recipients': 'Destinatários dos alertas',
        'Only me': 'Somente eu',
        '1 user (only me)': '1 usuário (somente eu)',
        'Once inactive, this rule will no longer generate alerts.':
            'Uma vez inativa, esta regra não gerará mais alertas.',
        Warning: 'Atenção',
        'Inactivate and edit': 'Inativar e editar',
        'For your own safety, an active rule can not be edited.':
            'Para sua própria segurança, uma regra ativa não pode ser editada.',
        'You must': 'Você deve',
        'deactivate the rule': 'desativar a regra',
        'before making any changes': 'antes de fazer qualquer alteração',
        'Unpublished changes': 'Alterações não publicadas',
        'Yes, I want to leave': 'Sim, quero sair',
        'Are you sure you want to leave without publishing it?': 'Tem certeza de que deseja sair sem publicá-lo?',
        'Yes, I want to': 'Sim, eu quero',
        'This will result in the loss of all edited information.':
            'Isso resultará na perda de todas as informações editadas.',
        'Are you sure you want to make the rule': 'Tem certeza de que deseja tornar a regra',
        'Delete Rule': 'Excluir regra',
        'Confirm deletion': 'Confirmar exclusão',
        'After deleting a rule': 'Após excluir uma regra',
        'the action cannot be undone': 'a ação não pode ser desfeita',
        'and any feature on the system that reads this rule will be affected.':
            'e qualquer recurso do sistema que leia esta regra será afetado.',
        'Are you sure you want to delete this rule?': 'Tem certeza de que deseja excluir esta regra?',
        Undo: 'Desfazer',
        '%n seconds': [
            [0, 1, 'segundo'],
            [2, null, 'segundos']
        ],
        '%n minutes': [
            [0, 1, 'minuto'],
            [2, null, 'minutos']
        ],
        '%n hours': [
            [0, 1, 'hora'],
            [2, null, 'horas']
        ],
        'Error fetching data.': 'Erro ao buscar dados.',
        'Error executing action.': 'Erro ao executar ação.',
        'CHANNELS ALERTS CONFIGURATION': 'CONFIGURAÇÃO DE ALERTAS DE CANAIS',
        'Are you sure you want to leave?': 'Tem certeza de que deseja sair?',
        'In this Channels Alerts version it is only possible to create personal alerts.':
            'Nesta versão do Channels Alerts, só é possível criar alertas pessoais.',
        'Loading...': 'Carregando...',
        'Cannot perform any other action, waiting for the ack event':
            'Não é possível realizar nenhuma outra ação, aguardando o evento de ack',
        AcknowledgedByChannels: AcknowledgedByChannelsPT,
        ResolvedByChannels: ResolvedByChannelsPT,
        FalsePositiveByChannels: FalsePositiveByChannelsPT,
        'The period in which the trigger condition was active until normalization.':
            'O período em que a condição de disparo estava ativa até a normalização.',
        'Confirms alert awareness. Does not resolve the alert cause.':
            'Confirma a ciência do alerta. Não resolve a causa do alerta.',
        'Trigger condition': 'Condição de disparo',
        'No active alerts related to the selected channel.':
            'Não há alertas ativos relacionados aos canais nesse dashboard.',
        'You may create a new rule or see the alerts history in the Alerts Monitoring.':
            'Você pode criar uma nova regra ou ver o histórico de alertas no Monitoramento de Alertas.',
        'See history': 'Ver histórico',
        Filter: 'Filtro',
        'See history in the Alerts Monitoring': 'Ver histórico no Monitoramento de Alertas',
        Alert: 'Alerta',
        'reported as false alert': 'relatado como alerta falso',
        resolved: 'resolvido',
        acknowledged: 'reconhecido',
        'Not sending alerts. Try to inactivate and activate it again.':
            'Não está enviando alertas. Tente inativá-lo e ativá-lo novamente.',
        Acknowledge: 'Reconhecer',
        'ALERT STATUS': 'STATUS DO ALERTA',
        Resolved: 'Resolvido',
        'False alert': 'Alerta falso',
        Channels: 'Canais',
        'Try searching again with a different term.': 'Tente pesquisar novamente com um termo diferente.',
        'Filter results': 'Resultados do filtro',
        'Clear all': 'Limpar tudo',
        'Click on any channel to select the attribute for your rule.':
            'Clique em qualquer canal para selecionar o atributo para sua regra.',
        'Channel Alerts': 'Alertas de Canais',
        'Channel Alert': 'Alerta de Canais',
        'Search items': 'Buscar itens',
        'Rule successfully published': 'Regra publicada com sucesso',
        'Could not select the channel': 'Não foi possível selecionar o canal',
        'Normalized after': 'Normalizado após',
        'No rules have been created yet': 'Nenhuma regra foi criada até o momento',
        'To create a channel alert rule, click on the "New rule" button.':
            'Para criar uma regra de alerta de canal, clique no botão "Nova regra".',
        'Rule successfully deactivated': 'Regra desativada com sucesso',
        'Rule name already exists.': 'Nome da regra existente',
        'Required field': 'Campo obrigatório',
        'Required field. This information must be filled.': 'Campo obrigatório. Esta informação deve ser preenchida.'
    }
}
